module.exports = __webpack_public_path__ + "static/img/manage.b7da57f.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/home/manage.png
// module id = sEqD
// module chunks = 1